export default function WineCard ({wine}) {
  return (
    <div className="wine-card">
      <h2>{wine.wine}</h2>
      <img src={wine.image} alt=""></img>
    </div>
  )
}